<style>
  .navbar {
    background-color: #505050;
    border-radius: 0;
  }

  .navbar-center {
    float: none;
    margin: 0 auto;
    display: table
  }

  .navbar-center li a {
    color: #fff;
  }
  .main-menu-section .navbar-nav li a {
    padding: 5px 10px;
    border-bottom: 3px solid #505050 !important;
  }
  .main-menu-section .navbar-nav li a:hover, .main-menu-section .navbar-nav li a.active{
    padding: 5px 10px;
    border-bottom: 3px solid #fff !important;
  }

  @media (min-width: 1366px) {
    .main-menu-section {
      width: 80%;
      margin: auto;
    }
  }
  
  @media (min-width: 768px) {
    .navbar-nav>li {
      padding:10px 8px;
    }
    .navbar-nav>li>a {
      text-transform: uppercase;
      font-size: 13px;
      cursor: pointer;
      padding: 0px 25px;
      font-weight: bold;
    }
    .form-horizontal .control-label{line-height:18px}
  }
  @media (min-width: 1024px) and (max-width:1365px) {
    .navbar-nav>li {
      padding:10px 0;
    }
    .floatLabelContainer [float-label] + label#label-class{max-width: 136px;
    white-space: nowrap;}
    }

    @media (min-width: 1024px) and (max-width: 1280px){
      .main-menu-section .navbar-nav li a{ 
        font-size: 11px; 
        padding: 5px 8px!important
      }
    }
   
</style>
<div class="main-menu-section">
  <ul class="nav navbar-nav navbar-center">
    <li  title="{{'dashboard-menu.Search'| translate | translateKey}}">
      <a [routerLink]="['/customerservice/search']" target="_blank" routerLinkActive="active">
       {{'dashboard-menu.FBO ACCOUNTS'|translate | translateKey}}
      </a>
    </li>
    <li *ngIf="ticketPermissions"  tabindex="0" title="{{'dashboard-menu.Tickets'| translate | translateKey}}">
      <a [routerLink]="['/customerservice/ticket/dashboard/worktickets']" target="_blank"  routerLinkActive="active" *ngIf="viewTicketDashboardPermission" >
        <!-- <i class="fa fa-tags pull-right menu-icon" title=" {{'dashboard-menu.Tickets'| translate | translateKey}}"></i> -->
        {{'dashboard-menu.Tickets'|translate | translateKey}}
      </a>
    </li>    
    <li *ngIf="hasOrderPermissions" title=" {{'dashboard-menu.Orders '| translate | translateKey}}">
      <a  [routerLink]="['/customerservice/orders']" routerLinkActive="active" target="_blank" >
        <!-- <i class="fa fa-cog pull-right menu-icon" title=" {{'dashboard-menu.New Order '| translate | translateKey}}"></i> -->
        {{'dashboard-menu.Orders'|translate | translateKey}}
      </a>
    </li>
    <li *ngIf="viewPOSOrderPermission" title=" {{'dashboard-menu.POS'| translate | translateKey}}">
      <a [routerLink]="['/customerservice/posorders']" routerLinkActive="active" target="_blank">
        <!-- <i class="fa fa-cubes pull-right menu-icon" title=" {{'dashboard-menu.Departments'| translate | translateKey}}"></i>    -->
        {{'dashboard-menu.POS'|translate | translateKey}}
      </a>
    </li>
    <li  *ngIf="viewAdminPermission" title=" {{'dashboard-menu.Admin'| translate | translateKey}}">
        <a [routerLink]="['/customerservice/admin']" routerLinkActive="active" target="_blank">
          <!-- <i class="fa fa-cubes pull-right menu-icon" title=" {{'dashboard-menu.Departments'| translate | translateKey}}"></i>    -->
           {{'dashboard-menu.Admin'|translate | translateKey}}
        </a>
    </li>
    <li *ngIf="hasAccessForFileUploads && enableFileUploads" title="{{'fileuploads.File Uploads'| translate | translateKey}}">
      <a [routerLink]="['/customerservice/fileuploads']" routerLinkActive="active" target="_blank">
         {{'fileuploads.File Uploads'|translate | translateKey}}
      </a>
    </li>
    <!-- <li *ngIf="isDepartmentPermissionAvailable()"  title=" {{'dashboard-menu.Departments'| translate | translateKey}}">
        <a [routerLink]="['/customerservice/departments/search']" routerLinkActive="active" >
           {{'dashboard-menu.Departments'| translate | translateKey}}
        </a>
      </li>
      <li *ngIf="isConfigurationPermissionAvailable()"  title=" {{'dashboard-menu.Configuration'| translate | translateKey}}">
        <a [routerLink]="['/customerservice/configuration/search']" routerLinkActive="active" >
          {{'dashboard-menu.Configuration'| translate | translateKey}}
        </a>
    </li> -->

    <li class="hide"  title=" {{'dashboard-menu.Knowledge Base'| translate | translateKey}}">
      <a [routerLink]="['/customerservice/knowledgebase']"  routerLinkActive="active">
        <!-- <i class="fa fa-book pull-right menu-icon" title=" {{'dashboard-menu.Knowledge Base'| translate | translateKey}}"></i> -->
        {{'dashboard-menu.Knowledge Base'| translate | translateKey}}
      </a>
    </li>

    <li *ngIf="hasAccessForReports" title="{{'dashboard-menu.REPORTS'|translate | translateKey}}">
      <a [routerLink]="['/customerservice/reports']" routerLinkActive="active" target="_blank">
         {{'dashboard-menu.REPORTS'|translate | translateKey}}
      </a>
    </li>
  </ul>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/views/app-main-menu-bar.component.html